import { render, staticRenderFns } from "./productSelection.vue?vue&type=template&id=5a0a9ac0&scoped=true&"
import script from "./productSelection.vue?vue&type=script&lang=js&"
export * from "./productSelection.vue?vue&type=script&lang=js&"
import style0 from "./productSelection.vue?vue&type=style&index=0&id=5a0a9ac0&prod&lang=scss&"
import style1 from "./productSelection.vue?vue&type=style&index=1&id=5a0a9ac0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a0a9ac0",
  null
  
)

export default component.exports